export const dataFinishedDateTime = {
  type: 'string',
  minLength: 1,
};
